import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaSwimmingPool, FaWifi, FaUtensils } from 'react-icons/fa';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-3">
            <div>
              <h1 className="text-2xl font-bold text-primary">Sunrise Agri Resorts</h1>
              <p className="text-sm text-gray-600">Experience Nature's Luxury</p>
            </div>
          </Link>
          
          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-primary font-medium transition-colors duration-200">Home</Link>
            <Link to="/services" className="text-gray-700 hover:text-primary font-medium transition-colors duration-200">Rooms & Pricing</Link>
            <Link to="/book-room" className="text-gray-700 hover:text-primary font-medium transition-colors duration-200">Book Now</Link>
            <Link to="/gallery" className="text-gray-700 hover:text-primary font-medium transition-colors duration-200">Gallery</Link>
            <Link to="/contact" className="text-gray-700 hover:text-primary font-medium transition-colors duration-200">Contact</Link>
            <Link to="/admin" className="text-gray-500 hover:text-primary font-medium transition-colors duration-200 text-sm">Admin</Link>
            <Link 
              to="/book-room" 
              className="bg-primary text-white px-6 py-2 rounded-full font-semibold hover:bg-primary-dark transition-colors duration-200 shadow-medium"
            >
              Book Your Stay
            </Link>
          </div>
          
          <div className="lg:hidden">
            <button onClick={toggleMenu} className="text-gray-700 focus:outline-none">
              {isOpen ? <FaTimes className="w-6 h-6" /> : <FaBars className="w-6 h-6" />}
            </button>
          </div>
        </div>
        
        {isOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="py-4 space-y-4">
              <Link to="/" className="block text-gray-700 hover:text-primary font-medium py-2" onClick={closeMenu}>Home</Link>
              <Link to="/services" className="block text-gray-700 hover:text-primary font-medium py-2" onClick={closeMenu}>Rooms & Pricing</Link>
              <Link to="/book-room" className="block text-gray-700 hover:text-primary font-medium py-2" onClick={closeMenu}>Book Now</Link>
              <Link to="/gallery" className="block text-gray-700 hover:text-primary font-medium py-2" onClick={closeMenu}>Gallery</Link>
              <Link to="/contact" className="block text-gray-700 hover:text-primary font-medium py-2" onClick={closeMenu}>Contact</Link>
              <Link to="/admin" className="block text-gray-500 hover:text-primary font-medium py-2 text-sm" onClick={closeMenu}>Admin</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;